 
import React, { memo } from "react";

const NotaDeCredito = () => {
  return <div>NotaDeCredito</div>;
};

export default memo(NotaDeCredito);
